import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
  mutation PayWithAdyenMutation($input: PayWithAdyenInput!) {
    payWithAdyen(input: $input) {
      merchantReference
      resultCode
      action
    }
  }
`;

function commit(environment, orderId, data, callback) {
  return commitMutation(environment, {
    mutation,
    variables: {
      input: {
        orderId,
        data,
      },
    },
    onCompleted: (response, errors) => {
      if (errors) {
        callback && callback(errors[0]);
      } else {
        callback && callback(null, response.payWithAdyen);
      }
    },
    onError: err => {
      callback && callback(err);
    },
  });
}

export default { commit };
